"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IHTTPAccept = void 0;
var IHTTPAccept;
(function (IHTTPAccept) {
    IHTTPAccept["ApplicationJsonCasecamelCase"] = "application/json; case=camelCase";
    IHTTPAccept["ApplicationJsonCasesnakeCase"] = "application/json; case=snake_case";
    IHTTPAccept["ApplicationJsonCaseAsIs"] = "application/json; case=AsIs";
})(IHTTPAccept || (exports.IHTTPAccept = IHTTPAccept = {}));
//# sourceMappingURL=http-accept.js.map